import styled from "styled-components";

export const SwitchWrapper = styled.div`
  display: inline-block;
  vertical-align: middle;
  box-sizing: border-box;
  ${({ disabled }) => disabled && `
    cursor: not-allowed;
    opacity: 0.5;
  `}

  input[type="checkbox"] {
    position: absolute;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    opacity: 0;
  }
  .switch_label {
    position: relative;
    cursor: pointer;
    display: inline-block;
    width: 60px;
    height: 28px;
    background: #d5d8de;
    border: 1px solid #d5d8de;
    // ${({ disabled }) => disabled && `
    //   background: #FF4242;
    //   border: 1px solid #FF4242;
    //   `}
    border-radius: 20px;
    transition: 0.2s;
  }
  .onf_btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    display: inline-block;
    width: 22px;
    height: 22px;
    border-radius: 22px;
    background: #fff;
    transition: 0.2s;
    margin: 0 3px;
    box-shadow: 0px 0px 4px 0px #B8BDC8;

  }
  input[type="checkbox"]:checked + .switch_label {
    background: #34e466;
    border: 1px solid #34e466;
  }
  input[type="checkbox"]:checked + .switch_label .onf_btn {
    left: 30px;
    background: #fff;
  }
`;
